import { clsx } from 'clsx'
import { type FC } from 'react'

import { type PimProductV11 } from '@redteclab/api/clients/bully'

import { useGlobalConfigContext } from '../../../../../global-config'
import { ProductPicture } from '../../../../../product'
import { TENANT } from '../../../../../tenant'
import { ProductBuyBoxStickyAddToCart } from '../ProductBuyBoxStickyAddToCart'

import { ProductBuyBoxStickyMobilePrice } from './ProductBuyBoxStickyMobilePrice'

export const ProductBuyBoxStickyMobile: FC<{
  product: PimProductV11
}> = ({ product }) => {
  const { tenant } = useGlobalConfigContext()
  const hasTenantImageStyles = [TENANT.AT, TENANT.COM, TENANT.FR].includes(
    tenant,
  )

  return (
    <div
      className={clsx(
        'fixed inset-x-0 bottom-0 z-10 bg-light-primary-low shadow-[0_6px_12px_#00000033] tablet:hidden',
        hasTenantImageStyles &&
          'flex flex-col items-center justify-between gap-2.5 p-6',
      )}
      data-clientside-hook="stickyBuyBox"
    >
      <div className="fixed inset-x-0 bottom-0 z-10 flex flex-col items-center justify-between bg-light-primary-low p-4 shadow-[0_6px_12px_#00000033] tablet:hidden">
        {hasTenantImageStyles ? (
          <div className="flex w-full flex-row justify-between">
            <h2 className="w-[82%] truncate text-m font-medium">
              {product.name}
            </h2>
            <ProductBuyBoxStickyMobilePrice product={product} />
          </div>
        ) : null}
        <div
          className={clsx(
            'flex w-full flex-row',
            !hasTenantImageStyles && 'items-center gap-2.5',
          )}
        >
          <ProductPicture
            className="shrink-0"
            imageProps={{
              alt: product.name,
              height: 55,
              src: product.images?.at(0),
              width: 55,
            }}
          />
          {hasTenantImageStyles ? null : (
            <ProductBuyBoxStickyMobilePrice product={product} />
          )}
          <ProductBuyBoxStickyAddToCart />
        </div>
      </div>
    </div>
  )
}
